export const getQualDrawCellClasses = (isFilteredByLocation) => {
    if (isFilteredByLocation) {
        return {
            qualDrawCellClass: 'qual-draw__cell hide-course-column',
            playerNameCellClass: 'qual-draw__cell-player-name qual-draw__cell-player-name__desktop',
            playerCellClass: 'qual-draw__cell--player qual-draw__cell--player__no-border'
        };
    }

    return {
        qualDrawCellClass: 'qual-draw__cell',
        playerNameCellClass: 'qual-draw__cell-player-name',
        playerCellClass: 'qual-draw__cell--player'
    };
};
